"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var textStyles = function (font, color, selectedTheme) {
    var resolvedColor = color ? (0, design_system_foundations_1.getPrefixedThemeColor)(color) : 'inherit';
    return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    color: ", ";\n  "])), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, font)), resolvedColor);
};
exports.Text = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'span' : _b, color = _a.color, children = _a.children, className = _a.className, font = _a.font, testId = _a.testId, rest = __rest(_a, ["as", "color", "children", "className", "font", "testId"]);
    if (color && !(0, design_system_foundations_1.getPrefixedThemeColor)(color)) {
        throw new Error("Invalid text color, valid color must be a theme or darkTheme color, and you passed in ".concat(color, "."));
    }
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var classes = (0, css_1.cx)(textStyles(font !== null && font !== void 0 ? font : 'body', color, selectedTheme), className, 'ds-text');
    return react_1.default.createElement(as || 'span', __assign({ className: classes, 'data-testid': testId, ref: ref }, rest), children);
});
exports.Text.displayName = 'Text';
var templateObject_1;
